import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';

@Component({
  selector: 'bank-account-register-success',
  templateUrl: './bank-account-register-success.component.html',
  styleUrls: ['./bank-account-register-success.component.scss'],
})
export class BankAccountRegisterSuccessComponent implements OnInit {
  @Input() public onContinueClick: EventEmitter<void> = new EventEmitter();

  public constructor(private store: Store<AppState>) {}

  public ngOnInit(): void {
    this.store.dispatch({
        type: TrackingActions.trackEvents,
        payload: {
            type: ActionEventsEnum.PAGE_LOADED,
            events: {
                'Product Area Origin': "Dados bancários",
                Status: "Cadastro de conta concluído",
                Step: "Feedback cadastrar dados da conta",
                'Time Responsável': "Sky"
            }
        },
    });
  }

  public continue(): void {
    this.store.dispatch({
        type: TrackingActions.trackEvents,
        payload: {
            type: ActionEventsEnum.ELEMENT_CLICKED,
            events: {
                'Product Area Origin': "Dados bancários",
                Element: "Botão Entendi",
                Step: "Feedback cadastrar dados da conta",
                Status: "Cadastro de conta concluído",
                'Time Responsável': "Sky"
            }
        },
    });
    this.onContinueClick.emit();
  }
}
